import { Fragment } from 'react';
import { TmdxAvatar } from '@ds';
import { ResourceAvatar } from '@ui';
import { getEmployeeName } from '@lp/features/RoutePlanner/components/RouteViewList/ResourcesLegInfo';
import {
  CaseClinicalSpecialistResource,
  CaseOCSConsoleResource,
  CaseResource,
  CaseRetrievalSurgeonResource,
} from '@/api/apis/case';
import { getFullName } from '@/utils/helpers';

type CompactResourcesListProps = {
  deviceList: CaseResource<CaseOCSConsoleResource>[];
  csList: CaseResource<CaseClinicalSpecialistResource>[];
  rsList: CaseResource<CaseRetrievalSurgeonResource>[];
  isScs: boolean;
};

export const CompactResourcesList = ({ csList, rsList, deviceList, isScs }: CompactResourcesListProps) => {
  const showMainResources = isScs || !!deviceList.length || !!csList.length;

  return (
    <>
      {showMainResources && (
        <div className="flex gap-1 items-center">
          {isScs && <ResourceAvatar type="scs" size="md" radius="md" />}
          {deviceList.map((r) => (
            <ResourceAvatar
              key={r.resourceId}
              src={r.data?.logoPath}
              type="device"
              organ={r.data?.organType}
              size="md"
              radius="md"
            />
          ))}
          {csList.map((r) => (
            <Fragment key={r.resourceId}>
              <TmdxAvatar
                size="md"
                radius="md"
                name={getFullName(r.data?.firstName, r.data?.lastName)}
                src={r.data?.profilePhoto}
              />
              <span className="text-m-r text-base-10">{getEmployeeName('CS', r.data)}</span>
            </Fragment>
          ))}
        </div>
      )}
      {rsList.map((r) => (
        <div key={r.resourceId} className="flex gap-1 items-center">
          <TmdxAvatar
            type="user"
            size="md"
            radius="md"
            name={getFullName(r.data?.firstName, r.data?.lastName)}
            src={r.data?.profilePhoto}
          />
          <span className="text-m-r text-base-10">{getEmployeeName('RS', r.data)}</span>
        </div>
      ))}
    </>
  );
};
